import React, {useState, useEffect, useRef} from 'react';
import './style.scss';
import media from '../../media';


export default function Banner(props) {
    const [activeIndex, setActiveIndex] = useState(0);
    let imageTimer = null;

    useEffect(()=> {
        if(props.content.bgs.length > 1) {
            updateImages();
        }

        return ()=> {
           clearInterval(imageTimer);
        }
    }, []);  
     
    return (
        <div className='banner'> 
            <div className='bgs' >
                {props.content.bgs.map((bg, index) => {
                    return (
                        <img className='bg' key={index} src={media[bg.img]} alt={bg.alt} style={{opacity:index===activeIndex?1:0}} />
                    )
                })}
            </div>

            <div className='overlay'>
                {props.overlay && <div className='overlay-bg' style={{opacity:props.overlay}}></div>}

                {props.content.text &&
                    <div className='overlay-text'>
                        <div className='text-wrapper'>
                            {props.content.text.title ? <h1 className='title' dangerouslySetInnerHTML={{__html:props.content.text.title}}></h1> : <></>}
                        </div>
                    </div>
                }
            </div>
        </div>
    );
     
    function updateImages(){
        let counter = 0;

        imageTimer = setInterval(() => {
            counter = counter == (props.content.bgs.length - 1) ? 0 : counter+1;
            setActiveIndex(counter);
        }, props.speed ? (props.speed*1000) : 3000)
    }
}
